import { faExclamationCircle } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  Heading,
  Inline,
  Modal,
  Stack,
  Text,
} from '@ui-lib';
import * as styles from './MaxPersonalCardsDialog.css';
import { useRouter } from 'next/router';
import useWorkspaceUrl from '@hooks/use-workspace-url';

type MaxPersonalCardsDialogProps = {
  show: boolean;
  planName: 'free' | 'premium' | 'team';
  maxCardNumber: number;
  close: () => void;
  handleUpgradeClick: () => void;
};

export function MaxPersonalCardsDialog({
  show,
  planName,
  close,
  handleUpgradeClick,
}: MaxPersonalCardsDialogProps): JSX.Element {
  const router = useRouter();
  const teamCardUrl = useWorkspaceUrl(`cards/team/`);

  let dialogText = '';
  let actionButtonText = '';

  if (planName === 'premium') {
    dialogText =
      'You have reached the limit for personal cards. If you are trying to create cards for your team you need to upgrade to a business plan.';
    actionButtonText = 'View Blinq Business features';
  }
  if (planName === 'team') {
    dialogText =
      'You have reached the limit for personal cards. If you are trying to create cards for your team you can go to the Team cards page and click Create new team card.';
    actionButtonText = 'Go to Team Cards page';
  }

  const handleActionBtnClick = () => {
    if (planName === 'team') {
      router.push(teamCardUrl);
    }
    if (planName === 'premium') {
      // Only open on premium, modal is self-aware of plan
      handleUpgradeClick();
      close();
    }
  };

  return (
    <Modal open={show} handleClose={close}>
      <Dialog>
        <DialogContent>
          <Box margin="small">
            <Stack gap="large">
              <Box className={styles.NotificationIcon} display="flex" justifyContent="center">
                <FontAwesomeIcon icon={faExclamationCircle} />
              </Box>
              <Heading level="6">Maximum number of personal cards reached</Heading>

              <Text className={styles.textStyle}>{dialogText}</Text>
            </Stack>
          </Box>
        </DialogContent>
        <DialogFooter>
          <Inline align="right" gap="small">
            <Button variant="text" onClick={close}>
              Cancel
            </Button>
            <Button variant="solid" onClick={handleActionBtnClick}>
              {actionButtonText}
            </Button>
          </Inline>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
